import React, { useContext, useEffect, useState } from "react";

import { FixtureDetailsContext } from "../../../../Config/FixtureDetails";
import { useIsVisible } from "../../../Base/Hooks/IsVisible";
import PositionHelper from "../../../Base/Utilities/PositionHelper";
import { sendPossessionEvent } from "../../../Base/Utilities/PossessionEvents";

const TeamSwitch = (props) => {
  const { currentState, panel, updateState } = props;
  const [isVisible, isEnabled] = useIsVisible(panel, props);
  const [scoreBannerLocked, setScoreBannerLocked] = useState(!!panel.options?.showBannerLock);
  const { sport } = useContext(FixtureDetailsContext);

  useEffect(() => {
    let tempEntities = currentState?.entities;
    if (tempEntities) {
      if (scoreBannerLocked) {
        if (!currentState.entityScoreBanner) {
          updateState("entityScoreBanner", [tempEntities[0].entityId, tempEntities[1].entityId]);
        }
      } else if (currentState.entityScoreBanner !== null && currentState.entityScoreBanner !== undefined) {
        // Don't write `null` when it's already null
        updateState("entityScoreBanner", null);
      }
    }
  }, [scoreBannerLocked, currentState.entities]);

  function handleLockClick() {
    setScoreBannerLocked(!scoreBannerLocked);
  }

  function switchTeams() {
    let tempEntities = currentState.entities;
    if (panel.sendUpdateArrow) {
      if (
        typeof tempEntities[0].hasArrow !== "undefined" &&
        tempEntities[0].hasArrow + tempEntities[1].hasArrow !== 0
      ) {
        tempEntities[0].hasArrow = !tempEntities[0].hasArrow;
      }
      if (
        typeof tempEntities[1].hasArrow !== "undefined" &&
        tempEntities[0].hasArrow + tempEntities[1].hasArrow !== 0
      ) {
        tempEntities[1].hasArrow = !tempEntities[1].hasArrow;
      }
      sendPossessionEvent(
        tempEntities[0].hasArrow ? tempEntities[0].entityId : tempEntities[1].entityId,
        "hasArrow",
        props,
      );
    }
    const newEntities = [tempEntities[1], tempEntities[0]];

    if (currentState.markerPos) {
      const actionPosition = PositionHelper.transformViewGamePosition(
        currentState.markerPos.x,
        currentState.markerPos.y,
        newEntities,
      );
      updateState("pos", { x: actionPosition.x, y: actionPosition.y });
      const newRegion = PositionHelper.getRegion(actionPosition.x, actionPosition.y, sport);
      updateState("region", newRegion);
    }

    updateState("entities", newEntities);
  }

  return (
    <React.Fragment>
      {isVisible && (
        <div className={panel.layout + " enabled-" + isEnabled}>
          {panel.options?.showBannerLock && (
            <div className="icon-button" onClick={(e) => handleLockClick()}>
              {scoreBannerLocked ? <i className="fas fa-lock"></i> : <i className="fas fa-lock-open"></i>}
            </div>
          )}
          <div onClick={(e) => switchTeams()}>
            <i className="fas fa-exchange-alt"></i>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default TeamSwitch;
